import { REALTIME_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CAMPAIGNS_GROUPS_REALTIME_REPORT_ID = `campaigns-groups${REALTIME_CAMPAIGN_SUFFIX}`;
